module.exports = __webpack_public_path__ + "static/cardpass-db6951d0596cca25f18d355baede08b1.svg";